<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white w-full mx-1 sm:w-1/3">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				Upload File
			</div>
			<div class="p-4" v-if="image!=''">
                <img :src="image" class="p-4 mb-2"/>
				<action-button class="flex items-center justify-between btn btn-blue py-2" @button-clicked="removeImage" v-if="image!=''">
					<trash-2-icon class="rounded w-5 h-5 cursor-pointer text-white"></trash-2-icon>
					Remove
				</action-button>
				
			</div>
			<div class="p-4">
				<input type="file" @change="onFileChange">
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-blue" @button-clicked="save">Send</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import AutoComplete from './AutoComplete.vue'
import { Trash2Icon } from 'vue-feather-icons'

export default {
    name: 'file-upload-modal',
	props: ['job', 'show', 'fileUpload'],
	data () {
		return {
			// errors: {
			// 	product_id: false,
			// 	qty: false,
			// 	comment: false,
            // },
            image: '',
			file: {
				phase_id: this.fileUpload.phase,
				area_id: this.fileUpload.area,
				block_id: this.fileUpload.block,
				unit_id: this.fileUpload.unit,
				job_id: this.fileUpload.job,
                name: null,
                content: null
            },
		}
	},
	methods: {
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.createImage(files[0]);
        },
        createImage(file) {
            var image = new Image();
            var reader = new FileReader();
			var vm = this;
			var d = new Date();
			var n = d.getTime();
            this.file.name = this.file.area_id+'-'+n+'-'+file.name;
            reader.onload = (e) => {
                vm.image = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage: function (e) {
            this.image = '';
             this.file.content = this.image;
              this.file.name = this.image;
            this.$store.commit('order/addAreaFile', {
                'areaId': this.fileUpload.area,
                'file': this.file
            });
        },
		checkForErrors () {
			var keys = Object.keys(this.errors)
			for (var i = keys.length - 1; i >= 0; i--) {
				if (String(this.product[keys[i]]).trim() === '') {
					this.errors[keys[i]] = true
				} else {
					keys.splice(i, 1)
				}
			}
			return keys.length
		},
		cancel () {
			// this.removeImage();
			this.$emit('close');
		},
		save () {
			// if (this.checkForErrors()) return;
            console.log(this.image);
            this.file.content = this.image;
            console.log(this.file);
            this.$store.commit('order/addAreaFile', {
                'areaId': this.fileUpload.area,
                'file': this.file
			});	
			this.$emit('close');
			// return;
			// console.log('here');
			// this.$http.post(`jobs/${this.job.id}/specialorders/`, this.product)
			// 	.then(response => {
			// 		let success = {
			// 			title: 'Action Successful',
			// 			message: 'Order Placed Successfully!',
			// 			type: 'success'
			// 		}
			// 		this.$store.commit('setStatus', success)	
			// 		this.$emit('reload')
			// 		this.$emit('close')
			// 	})
			// 	.catch(err => {
			// 		this.error = err
			// 	})
		}
	},
	computed: {
		// categoryName: function () {
		// 	return this.$store.getters.getProductCategoryNameById(this.specialOrder.catId)
		// },
		// options() {
		// 	return this.products.filter(product =>
		// 		product.name.toLowerCase().startsWith(this.searchText.toLowerCase())
		// 	)
		// 	.map(product =>
		// 		({
		// 			id: product.id,
		// 			name: product.name
		// 		})
		// 	);
		// },
		// catType: function(){
		// 	return this.$store.getters.getProductCategoryKeyByIndex(this.specialOrder.catId)
		// }
	},
	components: {
        // AutoComplete
		// FileUpload
		Trash2Icon
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		// this.product.type = this.$store.getters.getProductCategoryKeyByIndex(this.specialOrder.catId);
		// this.product.placed_by = this.$store.getters['auth/userid'];

		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		});

		// this.$http.post('productsbycategory',{
		// 	'category_id': this.specialOrder.catId
		// }).then((response) => {
		// 	this.products = response.data.products;
		// })
	}
}
</script>
